import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const Inventory = ({ inventory }) => {
  return(
    <tr>
      <td>{inventory.id}</td>
      <td>{inventory.item.name}</td>
      <td>{inventory.brand.brand_name}</td>
      <td className="hidden-xs-down">{inventory.extra_info && inventory.extra_info.grade ? inventory.extra_info.grade.grade : 'N/A'}</td>
      <td className="hidden-xs-down">{inventory.number_items}</td>
      <td className="hidden-xs-down">{inventory.price}</td>
      <td>
        <Link className="btn-sm btn-primary" to={`/pending_inventory/${inventory.id}`}>
          <i className="fa fa-balance-scale" />
        </Link>
      </td>
    </tr>
  )
}

export default class PendingInventoryList extends Component {
render() {
  const { inventories } = this.props;
  return (
    <tbody>
      {inventories.map(inventory => {
        return(
          <Inventory
            inventory={inventory}
            key={inventory.id}
          />
        )
      })}
    </tbody>
  );
}
}
